module.exports = __webpack_public_path__ + "img/capterra-logo.7af9fe3c.png";